import * as React from "react";

import Patterns from "@tunnel-components/@sharded/widgets/patterns-incident/component";
import SeaPatterns from "@tunnel-components/@sharded/widgets/sae/component";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import Stream from "@tunnel-components/@sharded/widgets/stream-live-incidents/component";
import StreamImage from "@tunnel-components/@sharded/widgets/stream/component";

import VideoStream from "@tunnel-components/@sharded/widgets/rtsp/component";
import SmallIncidentCart from "@tunnel-components/@sharded/widgets/small-incident-cart/component";
import HlsStream from "@tunnel-components/@sharded/widgets/hls/component";
import * as Utils from "@Cyclope-Utils/index";
import * as Lodash from "lodash";
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next";
import * as cx from "classnames";
import { isLessThan30Days } from "@Cyclope-Utils/index";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as Paths from "@tunnel-enums/index";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
// import Pdf from '@tunnel-components/@sharded/@widgets/pdfExport/component';
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org" selectedValue , onSearchValue ,
   */

  const {
    replayBlob,
    errorExportPdf,
    actionFalseAlarmPatterns,
    onClosePattern,
    timelineIncident,
    selectedValue,
    onSearchValue,
    viewSnapshot,
    viewSnapshotBoolean,
    identifiantActifSea /*,errorExportPdf*/,
    onClosehoverCard,
    errorExtractSequence,
    actionFalseAlarmPatternsError,
    onSubmitPatterns,
    onChangePatterns,
    patternfalseAlarm,
    selectedOptionsIncident,
    onSubmitSeaPatterns,
    onCloseSeaPatterns,
    actionSeaPatterns,
    positionVehicule,
    loading,
    btnloading,
    match,
    onChangeSource,
    errorserver,
    cameraBeforeAfter,
    onOpenhoverCard,
    openHoverCard,
    data,
    onQualified,
    direct,
    onDirectActive,
    onExportPDF,
    onExportSequence,
  } = props;

  ///  Simple Authorization + some operations

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean ( token )
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INCIDENTFILEQUALIFYINCIDENT,
  ]);

  const SYSTEMVIEWTUBES: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  // desturation

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isEmpty(data) && !Lodash.isUndefined(data) && !Lodash.isNull(data);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */

  const currentLabel = props.data && props.data.label ? props.data.label : null;
  return (
    <LayoutGrid
      dataUrlImage={data && data.snapshot}
      viewSnapshot={viewSnapshot}
      viewSnapshotBoolean={viewSnapshotBoolean}
      snackbarError={errorExtractSequence}
      someTextError={i18next.t("impossible d'extraire la séquence")}
      loading={loading}
      btnloading={btnloading}
      authorization={authorization}
      error={errorserver}
    >
      {data.fake && siteLoading && (
        <MessageEmptyIncidents
          message={i18next.t("cet incident est une simulation")}
        />
      )}
      {!isLessThan30Days(data) && siteLoading && !data.fake && (
        <MessageEmptyIncidents
          message={i18next.t("cet incident à plus de 30 jours")}
        />
      )}
      {siteLoading && isLessThan30Days(data) && !data.fake && (
        <section className="tunnel-site animated fadeIn">
          {data && (
            <BreadCrumb
              iconIncident={true}
              openHoverCard={openHoverCard}
              onOpenhoverCard={onOpenhoverCard}
              onClosehoverCard={onClosehoverCard}
              links={Paths.PathsNamesEnums.TUNNELWATCH}
              title={i18next.t("incidents")}
              onExtractPdf={onExportPDF}
              onExtractVideo={onExportSequence}
              breadText1={i18next.t("fiche incident")}
              breadText2={`${i18next.t(`${data.label}`)} #${
                match.params.incident
              }`}
              actionFinished={data.terminated}
              ficheIncident={isLessThan30Days(data)}
              actionInProgress={!data.terminated}
            />
          )}

          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="incident-items ">
                  <div className="incident-player">
                    {data.terminated && !replayBlob && (
                      <span className="animated fadeIn" />
                    )}
                    {data.terminated && replayBlob && (
                      <span className="borderGradian">
                        <span className="hls-active ">
                          <span className="textGradian">
                            {i18next.t("replay")}
                          </span>
                        </span>
                      </span>
                    )}
                    {!data.terminated && (
                      <div>
                        <span className={cx("", { borderGradian: direct[0] })}>
                          {" "}
                          {Utils.simpleAuthorizationIsAllowed(User, [
                            Enums.AuthorizationRightsEnums.CAMERAFLUXLIVE,
                          ]) && (
                            <span
                              className={cx("spanBGWithe", {
                                "hls-active ": direct[0],
                              })}
                              onClick={onDirectActive(0)}
                            >
                              {" "}
                              <span
                                className={cx("", { textGradian: direct[0] })}
                              >
                                {i18next.t("en direct")}
                              </span>
                            </span>
                          )}
                        </span>
                        <span
                          className={cx("", { borderGradian: direct[1] })}
                          style={{ marginLeft: "5px" }}
                        >
                          <span
                            className={cx("spanBGWithe", {
                              "hls-active": direct[1],
                            })}
                            onClick={onDirectActive(1)}
                          >
                            <span
                              className={cx("", { textGradian: direct[1] })}
                            >
                              {i18next.t("replay")}
                            </span>
                          </span>
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="one-incident-details with-1-3-columns ">
                    {data.terminated && (
                      <li className="cart-box-incidents">
                        <div className="cart-incident fiches ">
                          <div className="replay-hls">
                            {replayBlob && (
                              <VideoStream
                                localUrl={replayBlob}
                                id="incidentTimelineVideo"
                                className="image-live-replay animated fadeIn"
                              />
                            )}
                            {replayBlob && (
                              <div
                                id="seekCurrentIncident"
                                style={{ marginLeft: `${timelineIncident}%` }}
                              >
                                <StyledIcon arrowSeek={false} color="#FF024E" />
                              </div>
                            )}
                            {!replayBlob && (
                              <div
                                className="image-live-replay image-for-stream animated fadeIn"
                                style={{ cursor: "default" }}
                              >
                                <StreamImage
                                  localUrl={data.snapshot}
                                  name={
                                    data.camera ? data.camera.code : undefined
                                  }
                                  classnames=" animated fadeIn"
                                />
                              </div>
                            )}
                            {!replayBlob && (
                              <div className="infos-camera-bottom animated fadeInUp">
                                {i18next.t("km")}{" "}
                                {data.camera ? data.camera.location : ""} |{" "}
                                {data.camera ? data.camera.code : ""}
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                    )}
                    {!data.terminated && direct[0] && (
                      <li className="cart-box-incidents">
                        <div className="cart-incident fiches ">
                          <div className="replay-hls">
                            <li className="large-camera">
                              <div className="overlay-camera-large" />
                              <div
                                style={{ height: "100%" }}
                                id="largeImage"
                                onClick={onChangeSource}
                              >
                                <Stream
                                  localUrl={
                                    data.camera &&
                                    data.camera.liveIncidentUrl &&
                                    data.camera.liveIncidentUrl
                                  }
                                  classnames="image-live-replays"
                                />
                                <span className="infos-camera-bottom ">
                                  {i18next.t("km")}{" "}
                                  {data.camera ? data.camera.location : ""} |{" "}
                                  {data.camera ? data.camera.code : ""}
                                </span>
                              </div>
                            </li>
                            <li className="two-camera">
                              {cameraBeforeAfter &&
                                !Lodash.isUndefined(cameraBeforeAfter) &&
                                Lodash.isArray(cameraBeforeAfter) &&
                                cameraBeforeAfter.map(
                                  (item: any, index: number) => {
                                    return (
                                      <div
                                        key={index}
                                        className="top-two-camera smallImage"
                                        onClick={onChangeSource}
                                      >
                                        <Stream
                                          localUrl={
                                            item &&
                                            item.liveIncidentUrl &&
                                            item.liveIncidentUrl
                                          }
                                          classnames="image-live-replays"
                                        />
                                        <span className="infos-camera-bottom">
                                          {i18next.t("km")}{" "}
                                          {item ? item.location : ""} |{" "}
                                          {item ? item.code : ""}
                                        </span>
                                      </div>
                                    );
                                  }
                                )}
                            </li>
                          </div>
                        </div>
                      </li>
                    )}
                    {!data.terminated && direct[1] && (
                      <li className="cart-box-incidents">
                        <div className="cart-incident fiches">
                          <div className="replay-hls">
                            {data.camera.id && (
                              <HlsStream
                                localUrl={
                                  data.camera
                                    ? data.camera.replyIncidentUrl
                                    : ""
                                }
                                className="image-live-replay"
                              />
                            )}
                            <div className="hls-info-cam">
                              {i18next.t("km")}{" "}
                              {data.camera ? data.camera.location : ""} |{" "}
                              {data.camera ? data.camera.code : ""}
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                    <li className="cart-box-incidents animated slideInUp">
                      <div className="cart-incident fiches">
                        <div className="box-header-custom heightAuto">
                          {SYSTEMVIEWTUBES && (
                            <div className="header-fiches">
                              <span className=" headerSmallIncidentCart">
                                {i18next.t("description")}
                              </span>

                              <span
                                style={{
                                  backgroundColor:
                                    data.camera.section.colorRgbString,
                                  padding: "0 8px",
                                  marginLeft: "10px",
                                  color: "white",
                                  borderRadius: "0.2em",
                                }}
                              >
                                {data.camera.section.name}
                              </span>

                              <span style={{ height: "40px", float: "right" }}>
                                {false && (
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 26 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0)">
                                      <path
                                        d="M5.33333 6.19305V13.6422C5.33333 13.8924 5.53618 14.0952 5.78635 14.0952H9.85325V15.0821H9.12465C8.87448 15.0821 8.67164 15.2849 8.67164 15.5351C8.67164 15.7853 8.87448 15.9881 9.12465 15.9881H13.9487C14.1988 15.9881 14.4017 15.7853 14.4017 15.5351C14.4017 15.2849 14.1988 15.0821 13.9487 15.0821H13.2201V14.0952H17.287C17.5372 14.0952 17.74 13.8924 17.74 13.6422V6.19305C17.74 5.94284 17.5372 5.74004 17.287 5.74004H5.78635C5.53614 5.74004 5.33333 5.94284 5.33333 6.19305ZM12.3141 15.0375H10.7593V14.0953H12.3141V15.0375ZM6.23937 6.64607H16.834V13.1892H12.7671H10.3063H6.23937V6.64607Z"
                                        fill="#028DFF"
                                      />
                                      <path
                                        d="M21.3333 10.5807V3.13153C21.3333 2.88132 21.1305 2.67851 20.8803 2.67851H9.37962C9.12944 2.67851 8.9266 2.88132 8.9266 3.13153V4.88007C8.9266 5.13024 9.12944 5.33309 9.37962 5.33309C9.62979 5.33309 9.83263 5.13024 9.83263 4.88007V3.58455H20.4273V10.1277H19.0628C18.8127 10.1277 18.6098 10.3306 18.6098 10.5807C18.6098 10.8309 18.8127 11.0337 19.0628 11.0337H20.8803C21.1306 11.0337 21.3333 10.8309 21.3333 10.5807Z"
                                        fill="#028DFF"
                                      />
                                    </g>
                                    <path
                                      d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H22.3333C23.714 0.5 24.8333 1.61929 24.8333 3V17C24.8333 18.3807 23.714 19.5 22.3333 19.5H3C1.61929 19.5 0.5 18.3807 0.5 17V3Z"
                                      stroke="#028DFF"
                                    />
                                    <defs>
                                      <clipPath id="clip0">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                          transform="translate(5.33333 1.33333)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                        {actionSeaPatterns && (
                          <div className="boxContentSmallCartInsider">
                            <SeaPatterns
                              onSubmitSeaPatterns={onSubmitSeaPatterns(
                                match.params.incident
                              )}
                              onCloseSeaPatterns={onCloseSeaPatterns}
                            />
                          </div>
                        )}
                        {
                          /* !actionSeaPatterns*/ !Lodash.isEqual(
                            identifiantActifSea.id,
                            match.params.incident
                          ) &&
                            actionFalseAlarmPatterns && (
                              <div className="boxContentSmallCartInsider">
                                <Patterns
                                  name="patternfalseAlarm"
                                  onClosePattern={onClosePattern}
                                  selectedValue={selectedValue}
                                  onSearchValue={onSearchValue}
                                  actionFalseAlarmPatternsError={
                                    actionFalseAlarmPatternsError
                                  }
                                  onSubmit={onSubmitPatterns(
                                    match.params.incident,
                                    data.sea
                                  )}
                                  onChangePatterns={onChangePatterns}
                                  patternfalseAlarm={patternfalseAlarm}
                                  items={
                                    currentLabel
                                      ? selectedOptionsIncident.filter(
                                          (option: any) =>
                                            option.label !== currentLabel
                                        )
                                      : selectedOptionsIncident
                                  }
                                />
                              </div>
                            )
                        }
                        {
                          /* !actionSeaPatterns */ !Lodash.isEqual(
                            identifiantActifSea.id,
                            match.params.incident
                          ) &&
                            !actionFalseAlarmPatterns && (
                              <div className="boxContentSmallCartInsider">
                                <div className="boxContentSmallCart">
                                  <SmallIncidentCart
                                    viewSnapshot={viewSnapshot}
                                    data={data}
                                    positionVehicule={positionVehicule}
                                    params={match.params.incident}
                                  />
                                </div>

                                {!data.qualified && authorization && (
                                  <div className="box-footer-custom animated fadeInUp">
                                    <div className="box-center-display">
                                      <div className="left part-left">
                                        <span>{i18next.t("a qualifier")} </span>
                                      </div>
                                      <div className="left part-right">
                                        <span>
                                          <div
                                            className="icon-check left"
                                            onClick={onQualified(
                                              Number(match.params.incident),
                                              0
                                            )}
                                          />
                                          <div
                                            className="left icon-fauses-alert"
                                            onClick={onQualified(
                                              Number(match.params.incident),
                                              -1
                                            )}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {data.qualified && data.truePositive && (
                                  <div className="box-footer-custom out-of-qualified animated fadeInUp">
                                    <div className="box-center-display">
                                      <div className="left part-left">
                                        <span>{i18next.t("avere")}</span>
                                      </div>
                                      <div className="left part-right">
                                        <span>
                                          <div className="icon-check-green left" />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {data.qualified && data.falsePositive && (
                                  <div className="box-footer-custom out-of-qualified animated fadeInUp">
                                    <div className="box-center-display motifQualification">
                                      <div className="left part-left">
                                        <span>
                                          {i18next.t("fausse alerte")} :{" "}
                                          {i18next.t(
                                            `${data.qualificationMotifAs}`
                                          )}
                                        </span>
                                      </div>
                                      <div className="left part-right">
                                        <span>
                                          <div className="left icon-fauses-alert-gray" />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {!data.qualified && !authorization && (
                                  <div className="box-footer-custom  animated fadeInUp">
                                    <div className="box-center-display " />
                                  </div>
                                )}
                              </div>
                            )
                        }
                      </div>
                    </li>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorExportPdf}
        someTextSuccees={i18next.t(`impossible d'extraire le pdf`)}
      />

      {/* siteLoading && <Pdf/> */}
    </LayoutGrid>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  cameraBeforeAfter: [],
  cameradata: {},
  data: {},
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  replayBlob?: any;
  positionVehicule?: any;
  cameraBeforeAfter?: any;
  onOpenhoverCard?: any;
  openHoverCard?: any;
  data?: any;
  onQualified?: any;
  direct?: any;
  onDirectActive?: any;
  onExportPDF?: any;
  onExportSequence?: any;
  loading?: any;
  btnloading?: any;
  match?: any;
  onChangeSource?: any;
  errorserver?: any;
  actionFalseAlarmPatternsError?: any;
  actionFalseAlarmPatterns?: any;
  onSubmitPatterns?: any;
  onChangePatterns?: any;
  patternfalseAlarm?: any;
  selectedOptionsIncident?: any;
  onSubmitSeaPatterns?: any;
  onCloseSeaPatterns?: any;
  actionSeaPatterns?: any;
  errorExtractSequence?: any;
  errorExportPdf?: any;
  identifiantActifSea?: any;
  incident?: any;
  selectedValue?: any;
  onSearchValue?: any;
  timelineIncident?: any;
  onClosehoverCard?: any;
  viewSnapshot?: any;
  viewSnapshotBoolean?: boolean;
  onClosePattern?: any;
}

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/fiche/component.tsx